var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTool1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.1377 2.71453C2.1377 1.9537 2.75448 1.33691 3.51532 1.33691H16.1573C16.9181 1.33691 17.5349 1.9537 17.5349 2.71453V18.2893C17.5349 19.0501 16.9181 19.6669 16.1573 19.6669H3.51532C2.75448 19.6669 2.1377 19.0501 2.1377 18.2893V2.71453Z",
    fill: "#B9D6DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33789 4.18084C4.33789 3.42001 4.95467 2.80322 5.71551 2.80322H14.6915C15.4523 2.80322 16.0691 3.42 16.0691 4.18084V17.5116C16.0691 17.892 15.7607 18.2004 15.3803 18.2004H5.0267C4.64628 18.2004 4.33789 17.892 4.33789 17.5116V4.18084Z",
    fill: "#8CBBC8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1377 2.71453C2.1377 1.9537 2.75448 1.33691 3.51532 1.33691H13.2245C13.9853 1.33691 14.6021 1.9537 14.6021 2.71453V18.2893C14.6021 19.0501 13.9853 19.6669 13.2245 19.6669H3.51531C2.75448 19.6669 2.1377 19.0501 2.1377 18.2893V2.71453Z",
    fill: "#B9D6DE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83984 1.79612C6.83984 1.54251 7.04544 1.33691 7.29905 1.33691H11.7269C11.9805 1.33691 12.1861 1.54251 12.1861 1.79612V12.3603C12.1861 12.6637 11.8392 12.8363 11.5972 12.6533L9.73454 11.2449C9.60345 11.1458 9.42248 11.1458 9.2914 11.2449L7.42878 12.6533C7.18679 12.8363 6.83984 12.6637 6.83984 12.3603V1.79612Z",
    fill: "#62A1B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool1);
export default __webpack_public_path__ + "static/media/tool_1.32045921e07beddb45e3e4d66437c780.svg";
export { ForwardRef as ReactComponent };